<template>
    <div class="filter-item" @mouseleave="menuSecVisible = false">
        <div class="filter-title" @click="menuSecVisible = !menuSecVisible">{{ title }}</div>
        <i @click="menuSecVisible = !menuSecVisible"></i>
        <div class="pick-contain" v-show="menuSecVisible">
            <data-picker class="down_list" :data="data" :titleKey="titleKey" :pickIndex="pickIndex" @changed="pickChanged"></data-picker>
        </div>
    </div>
</template>
<script>
import DataPicker from '@/components/Pickers/data-picker.vue'
export default {
    name: 'FilterPick',
    components: { DataPicker },
    data() {
        return {
            menuSecVisible: false
        }
    },
    props: {
        data: {
            type: Array,
            default: () => []
        },
        titleKey: String,
        pickIndex: {
            type: Number,
            default: -1
        }
    },
    computed: {
        title: function () {
            if (this.pickIndex >= 0 && this.pickIndex < this.data.length) {
                var item = this.data[this.pickIndex]
                if (this.titleKey) {
                    return item[this.titleKey]
                }
                return item
            }
            return '默认标题'
        }
    },
    methods: {
        pickChanged(index) {
            this.$emit('update:pickIndex', index)
            this.menuSecVisible = false
        }
    }
}
</script>
<style lang="less" scoped>
.filter-item {
    height: 30px;
    line-height: 30px;
    width: 110px;
    border-radius: 15px;

    font-size: @font-size-normal;
    white-space: nowrap;
    color: @color-txt-normal;
    background-color: @bg-color-1E;
    position: relative;

    .filter-title {
        padding-left: 10px;
        padding-right: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    i {
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -4px;
        width: 13px;
        height: 7px;
        background: url(../assets/arrow_down.png) center no-repeat;
    }

    &:hover {
        cursor: pointer;
        color: @color-txt-high;

        i {
            background: url(../assets/arrow_down_1.png) center no-repeat;
        }
    }

    .pick-contain {
        position: absolute;
        left: 50%;
        top: 30px;
        width: 110px;
        z-index: 10;
        transform: translateX(-50%);
    }

    .down_list {
        margin-top: 10px;
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
        position: relative;

        &.visible {
            overflow-y: visible;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 2px;
            background-color: @main-green-color;
        }

        &::-webkit-scrollbar {
            width: 4px;
        }
    }
}
</style>
